
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 18a.5.5 0 01.492.41l.008.09v2.001a.5.5 0 01-.992.09l-.008-.09V18.5a.5.5 0 01.5-.5zm4.88-1.815l.07.058 1.415 1.415a.5.5 0 01-.638.765l-.07-.058-1.414-1.415a.5.5 0 01.637-.765zm-9.123.058a.5.5 0 01.058.637l-.058.07-1.415 1.415a.5.5 0 01-.765-.638l.058-.07 1.415-1.414a.5.5 0 01.707 0zM12 8a4 4 0 110 8 4 4 0 010-8zm8.501 3.5a.5.5 0 01.09.992l-.09.008H18.5a.5.5 0 01-.09-.992l.09-.008h2.001zM5.5 11.5a.5.5 0 01.09.992l-.09.008H3.499a.5.5 0 01-.09-.992l.09-.008H5.5zm12.865-5.865a.5.5 0 01.058.638l-.058.07-1.415 1.414a.5.5 0 01-.765-.637l.058-.07 1.415-1.415a.5.5 0 01.707 0zM6.273 5.577l.07.058L7.756 7.05a.5.5 0 01-.637.765l-.07-.058-1.415-1.415a.5.5 0 01.638-.765zM12 3a.5.5 0 01.492.41l.008.09V5.5a.5.5 0 01-.992.09L11.5 5.5V3.499a.5.5 0 01.5-.5z","fill":"#003653","fill-rule":"evenodd"}})])
          )
        }
      }
    